$ = require('jquery');

$(() => {
    let searchBar = $('.search-bar');
    let searchBarInput = $('.search-bar__input');
    let searchBarIcon = $('.search-bar__icon');
    
    searchBarIcon.on('click', () => {
        if (!searchBar.hasClass('open')) {
            searchBar.css('background-color', 'var(--global--color-background)');
            searchBar.addClass('open');
            setTimeout(() => {
                searchBarInput.css('opacity', '1');
            }, 500);
        }
    });
    
    $(document).on('click', (event) => {
        // ? if the target of the click isn't the container nor a descendant of the container... "click outside"
        if (!searchBar.is(event.target) && searchBar.has(event.target).length === 0) {
            if (searchBar.hasClass('open')) {
                searchBarIcon.css('pointer-events', 'none');
                searchBarInput.css('opacity', '0');
                searchBar.removeClass('open');
                setTimeout(() => {
                    searchBar.css('background-color', 'transparent');
                    searchBarIcon.css('pointer-events', 'auto');
                }, 500);
            }
        }
    });
})